import type { VideoBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface VideoBlockEditorProps {
  content: VideoBlockContent | null
  onChange: (content: VideoBlockContent) => void
}

export function VideoBlockEditor({ content, onChange }: VideoBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<VideoBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Video</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Video URL</Label>
          <Input
            value={c.url ?? ""}
            onChange={(e) => update({ url: e.target.value })}
            placeholder="https://youtube.com/watch?v=... or https://vimeo.com/..."
          />
        </div>
        <div>
          <Label>Caption (optional)</Label>
          <Input
            value={c.caption ?? ""}
            onChange={(e) => update({ caption: e.target.value })}
            placeholder="Caption below the video"
          />
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="video-autoplay"
            checked={c.autoplay ?? false}
            onChange={(e) => update({ autoplay: e.target.checked })}
            className="h-4 w-4 rounded border"
          />
          <Label htmlFor="video-autoplay">Autoplay</Label>
        </div>
      </CardContent>
    </Card>
  )
}
